// extracted by mini-css-extract-plugin
module.exports = {"tabpanel":"Indexpage_tabpanel__1toK1","allTitles":"Indexpage_allTitles__3gAIp"};